import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Seller guide routes. Mounted under PublicContentLayout — no app shell, no
// nav, no auth.
// - LEARN         : every guide in one searchable list
// - LEARN_ARTICLE : one guide, addressed by slug
//
// Deliberately no `meta.requiresAuth`: the guides explain what tokenised
// selling is, so gating them behind sign-in would hide them from exactly the
// reader they were written for. They hold no seller data — the content is
// identical for every visitor — so there is nothing here to protect.
//
// `meta.title` is the browser tab title for the index; article pages set theirs
// from the article itself.
export const learnRoutes: RouteRecordRaw[] = [
  {
    path: routes.LEARN,
    name: 'LEARN',
    component: () => import('./LearnIndexPage.vue'),
    meta: { title: 'Seller guides' },
  },
  {
    path: routes.LEARN_ARTICLE,
    name: 'LEARN_ARTICLE',
    component: () => import('./LearnArticlePage.vue'),
    meta: { title: 'Seller guides' },
  },
]
